import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * Custom hook to download the import template CSV for students or teachers.
 * Fetches the file as a blob from the API and triggers a browser download.
 */
export const useGetImportFormat = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const { axiosInstance } = useAxios();

    /**
     * Download the import template CSV
     * @async
     * @param {"students"|"teachers"} type - The type of template to download
     * @returns {Promise<void>}
     */
    const downloadTemplate = async (type) => {
        try {
            setLoading(true);
            setError("");

            const response = await axiosInstance.get(
                `${TENANT_DOMAIN}/import-template?type=${type}`,
                {
                    responseType: "blob",
                },
            );

            const blob = new Blob([response.data], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${type}_import_template.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            if (err?.response?.status === 500) {
                setError(ERROR_MESSAGES.INTERNAL_SERVER);
            } else {
                setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
            }
        } finally {
            setLoading(false);
        }
    };

    return {
        downloadTemplate,
        loading,
        error,
    };
};
